/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import FpTypedList from 'shared/ui/components/listings/FpTypedList.vue';
import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import backgroundExport from 'shared/ui/mixins/common/background-export';


const __vue_script__ = {
    name: 'FeedsList',

    components: { FpTypedList, DialogComponent, LoaderButton },

    mixins: [backgroundExport],

    props: {
        params: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        async downloadTranscripts(selectedItems = [], allItems = []) {
            const source = (selectedItems?.length) ? selectedItems : allItems;
            const ids = source.map(i => i._id).filter(Boolean);
            if (!ids.length) return;

            return this.createAndDownloadExport({
                eventId: this.params.event._id,
                jobAppScript: 'feed/transcript',
                jobParams: { ids },
                jobDocParams: {
                    name: this.$i18n.t('exports.feed_transcript_export.title').toString(),
                    fileName: 'feed_transcripts.zip'
                },
                pollEvery: 5000,
                timeout: 2
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feeds-list"},[_c('fp-typed-list',{staticClass:"generic-list",attrs:{"controller":_vm.params.currentController,"event":_vm.params.event,"module":_vm.params.module},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var allItems = ref.allItems;
return [_c('loader-button',{staticClass:"btn",attrs:{"type":"button","status":_vm.exporting},on:{"click":function($event){return _vm.downloadTranscripts(null, allItems)}}},[_vm._v(_vm._s(_vm.$t('exports.feed_transcript_export.action')))])]}},{key:"actions-after",fn:function(ref){
var selectedItems = ref.selectedItems;
var allItems = ref.allItems;
return [_c('loader-button',{staticClass:"btn",attrs:{"type":"button","status":_vm.exporting},on:{"click":function($event){return _vm.downloadTranscripts(selectedItems, allItems)}}},[_vm._v(_vm._s(_vm.$t('exports.feed_transcript_export.action')))])]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FeedsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__